<template>
  <div class="profile-read-more-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body div-responsive">
            <div class="row">
              <div class="col-2 d-flex align-items-center">
                <div v-if="specialist.photo != ''" class="rounded-image profile-image m-0">
                  <div class="profile-image-content">
                    <img :src="specialist.profileThumbnail" />
                  </div>
                </div>
                <div v-else class="rounded-image medium-rounded-image m-t-0 m-t-b">
                  <div class="profile-image-content notice-background"><s class="text-initials">{{getInitials(specialist)}}</s></div>
                </div>
              </div>
              <div class="col-10 pl-4">
                <div class="name">
                  {{ specialist.fullName }}
                  <img v-if="specialist.requiresTravel" class="icon-20" src="@/assets/images/travel_black_circle_icon.svg" />
                  <img v-if="specialist.videoLinkAvailable == 2" class="icon-20 ml-2" src="@/assets/images/video_black_icon.svg" />
                </div>
                <div class="qualification">
                  {{ specialist.qualificationList }}
                </div>
                <div class="download-pdf">
                  <v-btn dark v-if="specialist.id != ''" class="is-icon" data-placement="right" data-toggle="tooltip" title="Download PDF" @click="downloadPdf()" >Download as PDF</v-btn>
                </div>
              </div>

              <!-- <div class="col-12 specialist-pdf-title">

              </div> -->
            </div>
            <div class="box-row" v-if="specialist.educationList">
              <div class="box-col box-col-left">QUALIFICATIONS</div>
              <div class="box-col box-col-right m-auto">
                <div class="profile_input">{{specialist.educationList}}</div>
              </div>
            </div>
            <div class="box-row" v-if="specialist.certificationList">
              <div class="box-col box-col-left">ACCREDITATIONS</div>
              <div class="box-col box-col-right m-auto">
                <div class="profile_input">{{specialist.certificationList}}</div>
              </div>
            </div>
            <div class="box-row" v-if="specialist.interestList">
              <div class="box-col box-col-left">SPECIAL INTERESTS</div>
              <div class="box-col box-col-right m-auto">
                <div class="profile_input">{{specialist.interestList}}</div>
              </div>
            </div>
            <div class="box-row" v-if="specialist.personConditionList">
              <div class="box-col box-col-left">ASSESSMENT AREAS</div>
              <div class="box-col box-col-right">
                  <div class="profile_input">{{specialist.personConditionList}}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left mt-4">PROFILE</div>
              <div class="box-col box-col-right">
                <span v-html="specialist.specialistProfile" class="profile-details"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-html2pdf
        v-if="specialist.id"
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        :paginate-elements-by-height="1400"
        filename="SpecialistProfile"
        :pdf-quality="3"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        ref="html2Pdf"
        @hasDownloaded="hasDownloaded">
      <section slot="pdf-content">
        <PDFProfile :key="specialist.id" :availabilityStr="availabilities" ref="pdfProfile" :x="specialist" />
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import utilities from '@/assets/js/utilities'
import PDFProfile from "./pdfTemplate/PDFProfile.vue";

export default {
  name: "ProfileReadMoreModal",
  components: {
    PDFProfile
  },
  data() {
    return {
      availabilities: [],
      loadModal: false,
      specialist: utilities.initSpecialist(),
      note: "",
    }
  },
  methods: {
    hasDownloaded() {
      this.$store.dispatch('loading/setLoadComponent', false)
    },
    handleModal(e) {
      this.loadModal = !this.loadModal
      if(this.loadModal) {
        $("body>.tooltip").remove()
        utilities.initTooltip()
        $("html").addClass("modal-mask-open")
      } else {
        $("html").removeClass("modal-mask-open")
      }
    },

    getInitials(specialist) {
      var initials = ""
      if (specialist.firstName) {
        initials = specialist.firstName.substring(0,1)
      }

      if (specialist.lastName) {
        initials = initials + specialist.lastName.substring(0,1)
      }
      return initials
    },

    async downloadPdf() {
      this.$store.dispatch('loading/setLoadComponent', true)
      this.availabilities = await utilities.getSpAvailabilitiesNext3Days(this.specialist.id)
      console.log(this.availabilities)
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf()
        this.$store.dispatch('loading/setLoadComponent', false)
      }, 1000)
    },

    async loadData(id) {
      this.$store.dispatch('loading/setLoadComponent', true)
      this.specialist = await utilities.getSpecialistById(id)
      this.$store.dispatch('loading/setLoadComponent', false)
    },
  },
  mounted() {},
  updated() {},
}
</script>
